import React from 'react';
import { Button, Typography, useTheme, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/pro-duotone-svg-icons';

export type UploadButtonProps = {
    fileInputRef: React.RefObject<HTMLLabelElement>;
    smallUploadableBtn?: boolean;
};

const UploadButton: React.FunctionComponent<UploadButtonProps> = function (props) {
    const { fileInputRef, smallUploadableBtn = false } = props;
    const { palette } = useTheme();

    const uploadActionSx = {
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
        gap: '0 5px',
        fontSize: '14px',
        lineHeight: '17px',
        fontWeight: '500',
    };

    const uploadActionBtnSx = {
        padding: '0',
        fontSize: '14px',
        lineHeight: '17px',
        fontWeight: '500',
        color: `${palette.primary.dark}`,
    };

    return (
        <Typography
            component="div"
            sx={uploadActionSx}
        >
            {smallUploadableBtn ? (
                <Box sx={{ padding: '0 8px' }}>
                    <FontAwesomeIcon
                        style={{ cursor: 'pointer' }}
                        icon={faCloudArrowUp}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            fileInputRef?.current?.click();
                        }}
                    />
                </Box>
            ) : (
                <Box sx={{ display: 'flex', gap: '0 5px' }}>
                    <Button
                        data-testid="upload-btn"
                        sx={uploadActionBtnSx}
                        style={{ cursor: 'pointer' }}
                        variant="text"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            fileInputRef?.current?.click();
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faCloudArrowUp}
                            style={{ minWidth: '30px', minHeight: '30px' }}
                        />
                    </Button>
                </Box>
            )}
        </Typography>
    );
};

export default UploadButton;
